import { createColumnHelper, flexRender, getCoreRowModel, useReactTable } from "@tanstack/react-table";
import { useEffect, useState } from "react";
import { LabType } from "../types/labType";
import NumberInput from "./numberInput";
import StringInput from "./stringInput";
import { CellData } from "./cellData";
import { ActionsCell } from "./actionCell";

export const LabTable = (props:any) => {
     const refetchFunction = props.refetch;
      const tableData = props.data?props.data:[];
       const columnHelper = createColumnHelper<LabType>();
          const columns = [
       
            columnHelper.accessor((row) => row.roomName, {
              id: "roomName",
              header: () => <span className='d-flex text-black'>Lab Name</span>,
              cell: (props) =>  <CellData tableProps={props.row.original.roomName}  />
            }),
            columnHelper.accessor((row) => row.roomType, {
              id: "roomType",
              header: () => <span className='d-flex text-black'>Product</span>,
              cell: (props) =>  <CellData tableProps={props.row.original.roomType}   />
            }),
            columnHelper.accessor((row) => row.roomType, {
              id: "roomType",
              header: () => <span className='d-flex text-black'>Product</span>,
              cell: (props) =>  <ActionsCell tableProps={props.row.original} refetch={refetchFunction} />
            }),
          ];


         const table = useReactTable({
           data: tableData,
           columns,
           getCoreRowModel: getCoreRowModel(),    
});

       return (
    <div>
         <div className='admin-table'>
               <table className='table'>
             <thead>
               {table.getHeaderGroups().map(headerGroup => (
                 <tr className='text-center text-dark fw-bolder fs-6 MyReactTableClass' key={headerGroup.id}>
                   {headerGroup.headers.map(header => (
                     <th key={header.id}>
                       {flexRender(header.column.columnDef.header, header.getContext())}
                     </th>
                   ))}
                 </tr>
               ))}
             </thead>
             <tbody className='text-black fw-normal'>
               {table.getRowModel().rows.map(row => (
                 <tr key={row.id}  className="bg-white">
                   {row.getVisibleCells().map(cell => (
                     <td key={cell.id}>
                       {flexRender(cell.column.columnDef.cell, cell.getContext())}
                     </td>
                   ))}
                 </tr>
               ))}
             </tbody>
           </table>
          </div>
    </div>
  );
}